// extracted by mini-css-extract-plugin
module.exports = {"root":"Upstream_root__MSnZs","circle":"Upstream_circle__gQXiT","path":"Upstream_path__PH_GA","logo":"Upstream_logo__VHWoH"};